export const clientRoutes = [
  {
    path: '/clients',
    name: 'clients',
    component: () => import('./views/ListClients.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['superadmin'],
    },
  },
  {
    path: '/clients/add',
    name: 'client/add',
    component: () => import('./views/CreateClient.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['superadmin'],
    },
  },
  {
    path: '/clients/:id',
    name: 'clients/detail',
    component: () => import('./views/ClientDetail.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['superadmin'],
    },
  },
]
